import { CustomAbsolutePositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import { Theme } from "../../Theme";

export default function SingleCheckedDropdownMenu({ initValue, setValue, values, onClose, width = "232px" }) {
    const handleValueClick = (clickedValue) => {
        setValue(clickedValue);
        onClose();
    };

    return (
        <CustomAbsolutePositionDropdownWrapper width={width}>
            <SizedBox height={"12px"} />
            {values.map((v) => (
                <Row
                    key={v.value}
                    justifyContent={"space-between"}
                    gap={"8px"}
                    padding={"10px 20px"}
                    cursor={"pointer"}
                    onClick={() => handleValueClick(v.value)}
                >
                    <C3Text fontColor={Theme.color.zinc850}>{v.label}</C3Text>

                    {/* 선택 여부와 무관하게 체크 아이콘 영역을 확보해 너비가 흔들리지 않도록 한다. */}
                    <CustomIcon
                        iconName={"checked_active"}
                        size={"15.5px"}
                        isDisabled={initValue !== v.value}
                    />
                </Row>
            ))}
        </CustomAbsolutePositionDropdownWrapper>
    );
}
